import script from "./Collections.vue?vue&type=script&lang=ts&setup=true"
export * from "./Collections.vue?vue&type=script&lang=ts&setup=true"

import "./Collections.vue?vue&type=style&index=0&id=8da1b1be&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8da1b1be"]])

export default __exports__